import { SelectOption } from "@rio-cloud/rio-uikit";
import {
  getAccounts,
  getAssets,
  getBranch,
  getCategories,
  getDrivers,
  getSegments,
  getSubCategories,
  getSuppliers,
} from "../../services";
import { useEffect, useState } from "react";

export type FormState = {
  date: string;
  value: string;
  branch: string;
  segment: string;
  supplier: string;
  trip: string;
  vehicle: string;
  driver: string[];
  category: string;
  subcategory: string;
  observation: string;
};

const initialDefaultForm = {
  date: "",
  value: "",
  branch: "",
  segment: "",
  supplier: "",
  trip: "",
  vehicle: "",
  driver: [],
  category: "",
  subcategory: "",
  observation: "",
  taxes: "",
};

export const useExpensesForm = () => {
  const [branchOptions, setBranchOptions] = useState<SelectOption[]>([]);
  const [segmentsOptions, setSegmentsOptions] = useState<SelectOption[]>([]);
  const [supplierOptions, setSupplierOptions] = useState<SelectOption[]>([]);
  const [driversOptions, setDriversOptions] = useState<SelectOption[]>([]);
  const [categoriesOptions, setCategoriesOptions] = useState<SelectOption[]>([]);
  const [vehiclesOptions, setVehiclesOptions] = useState<SelectOption[]>([]);
  const [subCategoriesOptions, setSubCategoriesOptions] = useState<SelectOption[]>([]);

  const [form, setForm] = useState<FormState>(initialDefaultForm);

  const getDefaultOptions = (type: string) => {
    return [{ id: "Cadastrar novo(a)...", label: "Cadastrar novo(a)...", name: type }];
  };

  const mountOption = (data: any[]) => {
    return data?.map((res: { id: number; name: string }) => {
      return {
        id: res.id.toString(),
        label: res.name,
      };
    });
  };

  const fetchBranchOptions = async () => {
    try {
      const response = await getBranch();

      setBranchOptions(mountOption(response));
    } catch (error) {
      console.log("error", error);
      setBranchOptions(getDefaultOptions("branch"));
    }
  };

  const fetchSegments = async () => {
    try {
      const response = await getSegments();
      setSegmentsOptions(mountOption(response));
    } catch (error) {
      setSegmentsOptions(getDefaultOptions("segment"));
    }
  };

  const fetchSupplier = async () => {
    try {
      const response = await getSuppliers("FORNECEDOR");
      setSupplierOptions(mountOption(response.data));
    } catch (error) {
      setSupplierOptions(getDefaultOptions("supplier"));
    }
  };

  const getDriverName = (driver: Record<string, unknown>): string => {
    const firstName = driver.first_name ?? driver.firstName ?? driver.name ?? "";
    const lastName = driver.last_name ?? driver.lastName ?? driver.surname ?? "";
    const combined = `${firstName ?? ""} ${lastName ?? ""}`.trim();
    if (combined) return combined;
    return (driver.full_name as string) ?? (driver.displayName as string) ?? (driver.nickname as string) ?? "Motorista";
  };

  const fetchDrivers = async () => {
    try {
      const response = await getDrivers();
      setDriversOptions(
        response.map((driver: Record<string, unknown>) => ({
          id: String(driver.id),
          label: getDriverName(driver),
        }))
      );
    } catch (error) {
      setDriversOptions([]);
    }
  };

  const fetchVehicles = async () => {
    try {
      const response = await getAssets();
      setVehiclesOptions(mountOption(response.data));
    } catch (error) {
      setVehiclesOptions([]);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await getCategories();

      const filtered = response.filter((res: { type: "RECEITA" | "DESPESA" }) => res.type === "DESPESA");

      setCategoriesOptions(mountOption(filtered));
    } catch (error) {
      setCategoriesOptions(getDefaultOptions("category"));
    }
  };

  const fetchSubCategories = async () => {
    try {
      const response = await getSubCategories(form.category);
      setSubCategoriesOptions(mountOption(response.data));
    } catch (error) {
      setSubCategoriesOptions([]);
    }
  };

  useEffect(() => {
    if (form?.category) {
      fetchSubCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.category]);

  useEffect(() => {
    // fetchBranchOptions();
    // fetchSegments();
    // fetchSupplier();
    // fetchDrivers();
    // fetchCategories();
    // fetchVehicles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    segmentsOptions,
    branchOptions,
    supplierOptions,
    driversOptions,
    categoriesOptions,
    vehiclesOptions,
    subCategoriesOptions,
    form,
    initialDefaultForm,
    setForm,
    fetchBranchOptions,
    fetchSegments,
    fetchSupplier,
    fetchDrivers,
    fetchVehicles,
    fetchCategories,
    fetchSubCategories,
  };
};
